import Cookies from 'js-cookie'
import { convertCartToItems } from '@/util/gtm-helpers.js'
import Events from '../events'
import EventBus from '../event-bus'
import { PushDataLayerEvent } from '../core'
import logger from '../../logger'
import { calculateDollarDiscount } from '@/util'
import { LogoTracker } from '~/lib/events/tracker'

const handleTapfiliatePurchaseEvent = ({ order }) => {
  const revenue = order.total / 100
  window.tap('conversion', order.id, revenue, { customer_id: order.user })
  logger.debug('Tapfiliate conversion tracked')

  Cookies.remove('ref')
}

const handleLogoTrackerEvents = ({ order }) => {
  const planItem = order.items.find(item => item.package.type === 'plan')

  if (planItem) {
    LogoTracker.registerGlobalProperties({
      plan_level: planItem.package.code,
    })
  }
}

// Note: Google seems to require prices to be
// formatted like currency (1.99).  JS
// won't format numbers to that correctly,
// so it's important to take steps to convert
// your prices to currency when required.
const handleGAPurchaseEvents = ({ order, logo }) => {
  let items = convertCartToItems(order)

  if (order.total === 0) {
    return
  }

  const total = items.reduce((acc, product) => acc + product.price, 0)
  const discount = calculateDollarDiscount(order.total - order.tax, order.items)

  items = items.map(item => ({ ...item, price: item.price.toFixed() }))

  const totalValue = total - discount

  const payload = {
    coupon: order.coupon ? order.coupon.id : undefined,
    value: parseFloat(totalValue.toFixed(2)),
    transaction_id: order.id,
    affiliation: logo?.eid,
    shipping: 0,
    currency: order.currency.toUpperCase(),
    tax: order.tax,
    items,
  }

  EventBus.$emit(Events.EcommercePurchase, payload)
}

const handleGTMPurchaseEvents = ({ order }) => {
  const gtmParams = {
    coupon:
      order.coupon &&
      calculateDollarDiscount(order.total - order.tax, order.items) !== 0
        ? order.coupon.id
        : '',
    items: order.items,
    discount: calculateDollarDiscount(order.total - order.tax, order.items),
    order_id: order.id,
    total: order.total,
  }

  if (order.total === 0) {
    logger.debug(`Skipping analytics.  Reason: Order is free. Data:`, gtmParams)
  }

  PushDataLayerEvent({
    event: 'purchase_completed',
    ...gtmParams,
  })
}

const handleWebsiteProgressEvent = ({ order }) => {
  const site_item = order.items.find(item => item.package.type === 'site')
  if (site_item) {
    window.$nuxt.$store.dispatch('dashboard/markStepAsComplete', 'website')
  }
}

EventBus.$on(Events.PurchaseCompleted, handleTapfiliatePurchaseEvent)
EventBus.$on(Events.PurchaseCompleted, handleGAPurchaseEvents)
EventBus.$on(Events.PurchaseCompleted, handleGTMPurchaseEvents)
EventBus.$on(Events.PurchaseCompleted, handleWebsiteProgressEvent)
EventBus.$on(Events.PurchaseCompleted, handleLogoTrackerEvents)
